import React from 'react';
import { Card, Row, Col, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faHandHoldingHeart,
  faBell,
  faPoundSign
} from '@fortawesome/free-solid-svg-icons';
import {
  useDonorsCount,
  useActiveSponsorshipsCount,
  usePendingRemindersCount,
  useMonthlyDonationAmount
} from 'hooks/useDashboard';
import { formatMoney } from 'helpers/utils';

const StatCard = ({ title, value, icon, color, isLoading }) => {
  return (
    <Card className="h-100">
      <Card.Body>
        <div className="d-flex align-items-center">
          <div
            className={`rounded-circle d-flex align-items-center justify-content-center bg-soft-${color}`}
            style={{ width: 48, height: 48 }}
          >
            <FontAwesomeIcon icon={icon} className={`text-${color} fs-4`} />
          </div>
          <div className="ms-3">
            <h6 className="mb-1 text-600">{title}</h6>
            {isLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <h4 className="mb-0 text-800">{value}</h4>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

const StatsCards = () => {
  const { count: totalDonors, isLoading: donorsLoading } = useDonorsCount();
  const { count: activeSponsorships, isLoading: sponsorshipsLoading } =
    useActiveSponsorshipsCount();
  const { count: pendingReminders, isLoading: remindersLoading } =
    usePendingRemindersCount();
  const { amount: monthlyDonations, isLoading: donationsLoading } =
    useMonthlyDonationAmount();

  const stats = [
    {
      title: 'Total Donors',
      value: totalDonors,
      icon: faUsers,
      color: 'primary',
      isLoading: donorsLoading
    },
    {
      title: 'Active Sponsorships',
      value: activeSponsorships,
      icon: faHandHoldingHeart,
      color: 'success',
      isLoading: sponsorshipsLoading
    },
    {
      title: 'Pending Reminders',
      value: pendingReminders,
      icon: faBell,
      color: 'warning',
      isLoading: remindersLoading
    },
    {
      title: 'This Month',
      value: formatMoney(monthlyDonations),
      icon: faPoundSign,
      color: 'info',
      isLoading: donationsLoading
    }
  ];

  return (
    <Row className="g-3 mb-3">
      {stats.map((stat, index) => (
        <Col key={index} xs={6} lg={3}>
          <StatCard
            title={stat.title}
            value={stat.value}
            icon={stat.icon}
            color={stat.color}
            isLoading={stat.isLoading}
          />
        </Col>
      ))}
    </Row>
  );
};

export default StatsCards;
